const OPTIONS = [["en", "EN"], ["ar", "العربية"]];

export const LangSwitch = ({ lang, onChange, testid = "lang-switch", className = "" }) => (
  <div
    dir="ltr"
    role="group"
    aria-label="Language / اللغة"
    data-testid={testid}
    className={`inline-flex shrink-0 items-center rounded-full border border-current/10 p-1 text-sm font-semibold ${className}`}
    style={{ background: "color-mix(in srgb, currentColor 8%, transparent)" }}
  >
    {OPTIONS.map(([code, label], i) => (
      <span key={code} className="flex items-center">
        {i === 1 && <span aria-hidden className="mx-0.5 h-4 w-px bg-current opacity-20" />}
        <button
          type="button"
          lang={code}
          aria-pressed={lang === code}
          data-testid={`${testid}-${code}`}
          onClick={() => onChange(code)}
          className={`min-h-[34px] rounded-full px-3 transition-[background-color,color,opacity] duration-200 ${
            lang === code ? "bg-[var(--ls-active,#f97316)] text-white shadow-md" : "opacity-70 hover:opacity-100"
          }`}
          style={code === "ar" ? { fontFamily: "'Cairo','IBM Plex Sans Arabic',sans-serif" } : undefined}
        >
          {label}
        </button>
      </span>
    ))}
  </div>
);
